import React from "react";
import dayjs from "dayjs";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-grid.css";
import { Whisper, Popover } from 'rsuite';
import { useState, useMemo, useEffect, useRef } from "react";
import { FiSearch, FiFilter, FiDownload } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import PulseLoader from "../Utility/PulseLoader";
import CustomHeader from "../Utility/CustomHeader";
import ActionCellPharmacy from "../Utility/ActionCellPharmacy";
ModuleRegistry.registerModules([AllCommunityModule]);

function AllPharmacyDetails({ data = [], loading }) {
  const [searchTerm, setSearchTerm] = useState("");

  const CustomLoadingOverlay = () => (

    <div className="flex flex-col items-center justify-center h-full">
      <PulseLoader />

    </div>
  );

  const gridRef = useRef(null);



  const tableStyle = `

  .focus\:ring-\[\#00C335\]:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(21 44 64 / 68%);
}

  .btn-IdWmkZEQJd {
  border: none;
    background: #dcf2ff;
    color: #035ecf;
    width: 2.4rem;
    height: 2.4rem;
    display: flex
;
    align-items: center;
    justify-content: center;
    border-radius: .245rem;
    padding: .25rem .5rem;
  }


.ag-horizontal-right-spacer.ag-scroller-corner {
    display: none !important;
}

.ag-header-viewport {
  overflow-x: hidden !important;
  will-change: auto !important;
}

/* Soothing green strip for selected row */
.ag-theme-quartz .ag-row-selected::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #77c658; /* strip stays green */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  z-index: 1;
}

.ag-cell-value{
  border-left: unset !important;
  border-right: 1px solid #e5e5e5 !important;
}

.ag-column-first{
  border: unset !important;
}

.ag-theme-quartz .ag-row-selected::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #77c658; /* strip stays green */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  z-index: 1;
}

/* Override hover background for selected rows */
.ag-theme-quartz .ag-row-hover .ag-row-selected:hover {
  background-color: #f4fbf1 !important; /* same as selected */
}

.ag-checkbox-input-wrapper::before{
  display: none;
}

.ag-checkbox-input-wrapper::after{
  display: none;
}

  .ag-ltr .ag-sort-indicator-icon {
    padding-left: var(--ag-grid-size);
    display: none;
}

  .ag-header, .ag-advanced-filter-header {
    // background-color: #ff525a;
      background-color: #A2AD91;
    border-bottom: var(--ag-borders-critical) var(--ag-border-color);
}

            .ag-full-width-container{
            height : 100% !important;
          }


         

  
        .ag-header-cell-text {
        font-size: 0.9rem;
      text-transform: uppercase;
      color: #1e374f;
      font-weight: 600;
      font-family: 'Nunito', sans-serif !important;

        }

              .ag-header-cell-resize::after{
                      background-color: #1991eb52;
                  }



              .ag-ltr .ag-cell{

                      text-align: center;
                      display: flex;
                      // justify-content: center;
                      align-items: center;
              }

              .ag-header{
                  // background-color: #edeff6;
                   border: none;
                  padding: 0.5rem 0;

                  min-height: 44px !important;
              }

              .ag-row {
               border: 1px solid #eeedf0;

              }

                  .ag-row-odd {
    background-color: #fff !important; /* Light gray */
  }

                    .ag-row-even {
    background-color: #f7f7f7 !important; /* Light gray */
  }

.batch-column-border {
  border-left: 1px solid #ddd !important; /* continuous straight line */
  border-right: 1px solid #ddd !important; /* continuous straight line */
}





              .ag-root-wrapper{
                border: unset;
                background: transparent
              }

              .ag-body-viewport{
                
                border-top-left-radius: 5px !important;
                border-top-right-radius: 5px !important;
                
              }

              .ag-theme-quartz .ag-header-cell-filter-button{
              display: none;}

.ag-header-cell-resize:after {
    background-color: #1991eb52;
    content: "";
    display: block;
    height: 30%;
    position: absolute;
    top: calc(50% - 30% * .5);2px;
    z-index: 1;
}

               .ag-cell, .ag-cell-not-inline-editing, .ag-cell-normal-height, .ag-cell-value, .ag-cell-focus{
                  font-size: .9rem;
               }

        .ag-body-vertical-scroll{
            display : none;
          }

    .ag-header-cell-sortable .ag-header-cell-label{
           justify-content: start;
        }
        
        .ag-ltr .ag-cell {
            font-weight: 500 !important;
            letter-spacing: 0.5px;
            color: #2b2b2b !important;
        }


          .odd-row {
          background-color: #f8f8fc;
        }
        
        .span-saceuu7u7{
            font-size: 13px; 
            background-color: #FAAB3C; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .span-jkmkmkmkm{
            font-size: 10px; 
            color: #6941C6 ;
            border: solid .1px #6941C6; 
            background-color: #F9F5FF; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            width: 7rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .span-jkmkmkmkmjbui{
            font-size: 10px; 
            color: #175CD3 ;
            border: solid .1px #B2DDFF; 
            background-color: #EFF8FF; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            width: 7rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
                .ag-header-cell-label{
        display: flex;
        justify-content: center;
        }
         .ag-cell:focus,
  .ag-cell-focus,
  .ag-row-focus {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }

        
        
  
  `;
  const navigate = useNavigate();

  const getStableColor = (key) => {
    const bgColors = [
      "bg-danger bg-opacity-50",
      "bg-success bg-opacity-50",
      "bg-primary bg-opacity-50",
      "bg-warning bg-opacity-50",
     
    ];

    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = key.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % bgColors.length;
    return bgColors[index];
  };

  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    if (!gridRef.current || !gridRef.current.api) return;

    const api = gridRef.current.api;

    if (loading) {
      api.showLoadingOverlay();
    } else if (!loading && rowData.length === 0) {
      api.showNoRowsOverlay();
    } else {
      api.hideOverlay();
    }
  }, [loading, rowData]);



  useEffect(() => {
    setRowData(data);
  }, [data]);



  const [colDefs, setColDef] = useState([
  
  {
  headerName: "Item",
  field: "itemImage", // This should be the URL or object with image info
  width: 170,
  minWidth: 120,
  suppressSizeToFit: true,
  sortable: true,
  filter: true,
  cellClass: "batch-column-border", 
  cellRenderer: function (params) {
    const imageUrl = params.value; // or extract from object if needed
    return (
      <div className="d-flex align-items-center gap-2">
        <img 
          src={imageUrl} 
          alt="Item" 
          style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px', padding: '8px' }} 
        />
        {/* Optional: include a name or label next to the image */}
        {/* <span className="fw-bold text-secondary small">Item Name</span> */}
      </div>
    );
  }
},




    {
      headerName: "Product Name",
      field: "productName",
      width: 170,
      minWidth: 170,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: function (params) {
        const name = params.value || "U";
        const initial = name.charAt(0).toUpperCase();
        const bgColor = getStableColor(name);

        return (
          <div className="d-flex align-items-center gap-2">
            <div
              className={`d-flex justify-content-center align-items-center rounded-circle text-white fw-bold ${bgColor}`}
              style={{ width: "2rem", height: "2rem", fontSize: "0.9rem" }}
            >
              {initial}
            </div>
            <span className="fw-bold text-dark ">{name}</span>
          </div>
        );
      },
    },

{
  headerName: "Batch No",
  field: "batchNo",
  width: 170,
  minWidth: 170,
  suppressSizeToFit: true,
  sortable: true,
  filter: true,
  cellClass: "batch-column-border", 
  cellRenderer: function (params) {
    const batch = params.value || "U";
    return (
      <div className="d-flex align-items-center gap-2" >
        
        <span className="fw-bold text-dark ">{batch}</span>
      </div>
    );
  }
},
    
    {
      headerName: "Pack",
      field: "pack",
      minWidth: 100,
      cellRenderer: (params) => (
        <span className="text-secondary fw-semibold medium">{params.value}</span>
      ),
    },
    {
      headerName: "Expiry Date",
      field: "date",
      minWidth: 170,
      cellRenderer: function (params) {

        const formattedDate = dayjs(params.value)
          .format("DD-MMM-YYYY")
          .replace(
            /-(\w{3})-/,
            (_, month) =>
              `-${month.charAt(0).toUpperCase()}${month
                .slice(1)
                .toLowerCase()}-`
          );
        return (
          <>
            <span className= "text-dark  fw-bold ">
              {formattedDate}
            </span>
          </>
        );
      },
    },
    

    
    {
      headerName: "Status",
      field: "status",
      minWidth: 150,
      cellRenderer: (params) => {
        const status = params.value;

        const statusStyles = {
          Confirmed: "border-1 border-blue-500 text-blue-500 bg-transparent",
          "In Progress": "bg-amber-400 text-white",
          InStock: "bg-emerald-500 text-white",
          Cancelled: "bg-red-500 text-white",
          OutOfStock: "bg-[rgb(209,74,74)] text-white border-[rgb(209,74,74)]",
          LowStock: "bg-[#63b1f1] text-white",
        };

        return (
          <span
            className={`inline-flex items-center justify-center rounded-full text-xs font-semibold h-7 w-[110px] px-3 ${statusStyles[status] || "bg-gray-400 text-white"}`}
            style={{ minWidth: "110px", textAlign: "center" }}
          >
            {status}
          </span>
        );
      },
    },
 

 {
  headerName: "MRP",
  field: "mrp",
  minWidth: 140,
  cellRenderer: (params) => {
    const value = params.value || "";
    const match = value.match(/^([^()]+)\(([^)]+)\)?$/);

    const mainRate = match?.[1]?.trim() || value;       // e.g. ₹100
    const secondLine = match?.[2]?.trim() || "";        // e.g. Mar:22.06%

    return (
      <div className="text-dark fw-medium medium">
        <div>{mainRate}</div>
        {secondLine && (
          <div className="text-xs text-dark fw-bold">{secondLine}</div>
        )}
      </div>
    );
  }
},

     {
      headerName: "Purc Rate",
      field: "purchaseRate",
      minWidth: 140,
      cellRenderer: (params) => (
        <span className="text-secondary fw-medium medium">{params.value}</span>
      ),
    },
     {
  headerName: "Net Rate",
  field: "netRate",
  minWidth: 140,
  cellRenderer: (params) => {
    const value = params.value || "";
    const match = value.match(/^([^()]+)\(([^)]+)\)?$/);

    const mainRate = match?.[1]?.trim() || value;       // e.g. ₹100
    const secondLine = match?.[2]?.trim() || "";        // e.g. Mar:22.06%

    return (
      <div className="text-dark fw-medium medium">
        <div>{mainRate}</div>
        {secondLine && (
          <div className="text-xs text-dark fw-bold">{secondLine}</div>
        )}
      </div>
    );
  }
},


    {
  headerName: "Sale Rate",
  field: "saleRate",
  minWidth: 140,
  cellRenderer: (params) => {
    const value = params.value || "";
    const match = value.match(/^([^()]+)\(([^)]+)\)?$/);

    const mainRate = match?.[1]?.trim() || value;       // e.g. ₹100
    const secondLine = match?.[2]?.trim() || "";        // e.g. Mar:22.06%

    return (
      <div className="text-dark fw-medium medium">
        <div>{mainRate}</div>
        {secondLine && (
          <div className="text-xs text-secondary">{secondLine}</div>
        )}
      </div>
    );
  }
},



    


   {
  headerName: "Stock Qty",
  field: "stock",
  minWidth: 140,
  cellRenderer: (params) => {
    const value = params.value || "";
    const match = value.match(/^([^()]+)(\([^)]+\))?$/); // split main value and bracket part

    const mainRate = match?.[1]?.trim() || "";
    const bracketPart = match?.[2]?.trim() || "";

    return (
      <div className="text-dark fw-bold ">
        <div>{mainRate}</div>
        {bracketPart && <div className="small text-muted">{bracketPart}</div>}
      </div>
    );
  }
},


    {
      headerName: 'Actions',
      field: 'Actions',
      minWidth: 100,
      cellRenderer: ActionCellPharmacy,
    },
  ]);

  const autoSizeStrategy = {
    type: "fitGridWidth",
    columnLimits: [
      {
        colId: "No of Team Members",
        minWidth: 900,
      },
    ],
  };

  const paginationPageSizeSelector = useMemo(() => {
    return [10, 20, 50, 100];
  }, []);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      sortable: true,
      enableRowGroup: true,
      sort: "asc",
      resizable: true,
      headerComponent: CustomHeader,
    };
  }, []);

  const rowSelection = {
    mode: "multiRow",
    headerCheckbox: true,
  };
  const CustomNoRowsOverlay = () => (
    <div className="flex flex-col items-center justify-center h-full">
      <img
        src="/Images/doctortable.png"
        alt="No doctors available"
        className="w-64 h-64 object-contain mb-6"
      />
      <p className="text-gray-600 text-lg font-semibold">No Appointments Available</p>
    </div>
  );
  return (
    <>
     

          {/* Heading */}
          {/* <div>
            <h2 className="text-xl xl:text-2xl font-bold leading-tight tracking-tight mb-2 text-[#213343]">
              All Appointments
            </h2>
            <div className="text-sm text-muted-foreground">
              View and manage all scheduled appointments.
            </div>
          </div> */}

          {/* Actions */}
          {/* <div className="flex flex-wrap gap-2 items-center">
            <div className="relative">
              {" "}
              <FiSearch className="absolute left-3 top-2.5 h-4 w-4 text-[#00C335]" />{" "}
               <input
                type="search"
                placeholder="Search prescriptions..."
                className="w-full pl-10 pr-4 py-2 h-10 rounded-full border border-gray-300 placeholder:text-gray-500 text-sm focus:outline-none focus:ring-2 focus:ring-[#00C335] transition"
              />{" "}
       
            </div>

            <AppointmentFilterPopover />

            <button
              type="button"
              className="inline-flex items-center justify-center size-10 rounded-md border border-gray-300 hover:bg-[#E6FCEA] hover:text-[#00C335] text-[#213343] focus:ring-2 focus:ring-[#00C335]"
            >
              <FiDownload className="h-4 w-4" />
            </button>
          </div> */}
       

        <div style={{ width: "100%", height: "100%" }}>
          {/* Grid wrapper */}
          <div
            id="grid-wrapper"
            className="ag-theme-quartz custom-ag-grid"
            style={{
              width: "100%",
              height: "100%",
              boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
              borderRadius: "12px",
              backgroundColor: "#fff",
              minHeight: "32rem",
            }}>
            <style>{tableStyle}</style>
            <AgGridReact
              rowData={rowData}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              rowClass="tbl-row-sc"
              ref={gridRef}
              loadingOverlayComponent={CustomLoadingOverlay}
              noRowsOverlayComponent={CustomNoRowsOverlay}  
              rowHeight={50}
              headerHeight={30}
              autoSizeStrategy={autoSizeStrategy}
            />
          </div>
        </div>
    </>
  );
}

export default AllPharmacyDetails;
